<template>
  <div v-if="currentGroup">
      <div v-if="currentGroup.groupComms && currentGroup.groupComms !== 'myreflections'">

          <card shadow type="default" class="text-center p-5 text-white">

            <div v-if="currentGroup.groupComms === 'custom'">

                <h5 class="text-white">
                    We have a group chat/messaging hosted external to My Reflections
                </h5>
                <a :href="currentGroup.groupCommsLink" target="_blank">
                  <base-button type="white">
                    <i class="mr-2 fal fa-smile"></i> join us!
                  </base-button>
                </a>

            </div>

            <div v-else>

                <h5 class="text-white">
                    We are using {{ currentGroup.groupComms | capitalize }} for our group communications!
                </h5>
                <a :href="currentGroup.groupCommsLink" target="_blank">
                  <base-button type="white" class="mt-3">
                    <i :class="commsIcon"></i> join us now!
                  </base-button>
                </a>

            </div>

            
          </card>

      </div>
      <div v-else>

        <div class="card nobody rounded">
          <textarea-autosize placeholder="What do you want talk about..." ref="grouppostTextaea" v-model="form.grouppost" :min-height="30" class="form-control shadow input-lg border-0" />

          <div class="card-footer bg-default p-1">
            <button class="btn btn-sm btn-secondary float-right mr-0" @click="commitGroupPost" v-if="form.grouppost">POST</button>
            <button class="btn btn-sm btn-secondary disabled float-right mr-0" disabled v-else>POST</button>
            <span class="float-right btn btn-sm btn-outlined-secondary text-white" title="Send group members an email" v-if="currentGroup && currentGroup.ownerId === user.data.uid && !form.emailNotice" @click="form.emailNotice = !form.emailNotice">
              <i class="fad fa-envelope"></i>
            </span>
            <span class="float-right btn btn-sm btn-secondary" title="Send group members an email" v-else-if="currentGroup && currentGroup.ownerId === user.data.uid && form.emailNotice" @click="form.emailNotice = !form.emailNotice">
              <i class="fad fa-envelope"></i>
            </span>

            <ul class="nav nav-pills text-white">
              <li class="nav-item">
                <a role="button" class="pointer ml-2" @click="toggleSubPanel('report')"><i class="fad fa-calendar-week"></i></a>
              </li>
              <li class="nav-item">
                <a role="button" class="pointer ml-1" @click="toggleSubPanel('image')"><i class="fad fa-camera"></i></a>
              </li>
              <li class="nav-item">
                <a role="button" class="pointer ml-1" @click="toggleSubPanel('video')"><i class="fad fa-play"></i></a>
              </li>
              <li class="nav-item">
                <a role="button" class="pointer ml-1" @click="toggleSubPanel('website')"><i class="fad fa-browser"></i></a>
              </li>
              <li class="nav-item">
                <a role="button" class="pointer ml-1" @click="toggleSubPanel('poll')"><i class="fad fa-poll-h"></i></a>
              </li>
            </ul>

            <!-- WEEKLY REPORT SUPPORT -->
            <div class="alert alert-secondary mt-2 mb-0" v-if="subPanel === 'report'">
              <p>Choose which report you would like to share with the group:</p>

              <div v-if="publicReportsLoading">
                <i class="fad fa-spinner-third fa-2x fa-spin"></i>
              </div>

              <div class="form-group mt-2" v-show="sortedReports.length > 0">
                <select class="form-control" v-model="form.attachmentSelected" @change="setReportAttachment">
                  <option selected :value="null" disabled>- choose a public report to share -</option>
                  <option :value="ri" v-for="(report, ri) in sortedReports" v-bind:key="ri">
                    {{ report.label ? report.label : "Unnamed report" }} 
                    [ {{ $dayjs( report.startDate ).format("MMM Do, YYYY") }} ]
                  </option>
                </select>

                <report-share :share-link="shareLink" v-if="form.attachment.url"></report-share>

                <div class="mt-4 alert alert-default" v-if="form.attachment.url">
                  <p>Please note that this will share all of your shared report, not only those reflections and details associated with this group</p>
                  <base-button @click.prevent="closeAttachment" type="white"> Cancel </base-button>
                </div>
              </div>

              <div class="mt-4 text-default" v-if="!publicReportsLoading && sortedReports.length === 0">You currently have no <b>public</b> reports available for sharing</div>
            </div>

            <!-- IMAGE SUPPORT -->
            <div class="alert alert-secondary mt-2 mb-0" v-if="subPanel === 'image'">
              <p>Choose which image(s) you would like to share with the group:</p>

              <vue-dropzone ref="imgDropZone" id="customdropzone" :options="dropzoneOptions" class="mt-2" @vdropzone-complete="afterComplete"></vue-dropzone>

              <div v-show="imageLinks.length > 0" class="mt-3 d-flex flex-wrap">
                <div v-for="(image, index) in imageLinks" :key="index" style="position: relative">
                  <img :src="image.src" class="preview-image border border-1 border-muted p-2" />
                  <span class="btn btn-sm btn-default" style="position: absolute; top: 30px; right: 30px" @click="deleteImage(image, index)">
                    <i class="fad fa-trash"></i>
                  </span>
                </div>
              </div>
            </div>

            <!-- VIDEO SUPPORT -->
            <div class="alert alert-secondary mt-2 mb-0" v-if="subPanel === 'video'">
              <div class="float-right text-uppercase text-muted">
                <small class="mr-1">SUPPORTS</small>
                <i class="fab fa-youtube mr-1" title="YouTube"></i>
                <i class="fab fa-vimeo mr-1" title="Vimeo"></i>
                <i class="icon-wistia mr-1" title="Wistia"></i>
                <i class="fab fa-dailymotion mr-1" title="Daily Motion"></i>
                <i class="icon-coub" title="Coub"></i>
              </div>

              <p>Choose which video you would like to share with the group:</p>

              <div class="input-group mt-2 mb-2">
                <input type="input" placeholder="Add your video link" v-model="form.attachment.url" class="form-control" />
                <div class="input-group-append" v-if="form.attachment.url">
                  <button class="btn btn-default" type="button" id="button-addon2" @click.prevent="closeAttachment"><i class="fas fa-times"></i></button>
                </div>
              </div>

              <video-embed class="rounded" :src="form.attachment.url" v-if="form.attachment.url"></video-embed>
            </div>

            <!-- WEBSITE SUPPORT -->
            <div class="alert alert-secondary mt-2 mb-0" v-show="subPanel === 'website'">
              <p>Enter the website you would like to link:</p>

              <div class="input-group mt-2 mb-2">
                <input type="input" placeholder="Add your video link" v-model="form.attachment.url" class="form-control" />
                <div class="input-group-append" v-if="form.attachment.url">
                  <button class="btn btn-default" type="button" id="button-addon2" @click.prevent="closeAttachment"><i class="fas fa-times"></i></button>
                </div>
              </div>

              <link-prevue ref="linkPreview" :url="form.attachment.url" v-show="form.attachment.url" cardWidth="100%" :showButton="false">
                <template slot="loading">
                  <!-- set your custom loading -->
                  <div class="text-center text-default">
                    <i class="fad fa-spinner-third fa-2x fa-spin"></i>
                  </div>
                </template>

                <template slot-scope="props">
                  <div class="card shadow" v-if="props.title">
                    <div class="d-flex flex-row align-items-center">
                      <div class="p-2 align-lg-left align-center">
                        <img class="card-img-top" :src="props.img" :alt="props.title" />
                      </div>
                      <div class="p-2 text-lg-left text-center">
                        <h5 class="text-default font-weight-bold">{{ props.title }}</h5>
                        <p class="card-text">{{ props.description }}<br /></p>
                        <a v-bind:href="props.url" class="btn btn-sm btn-primary">More</a>
                      </div>
                    </div>
                  </div>
                  <div class="card shadow p-2" v-else>
                    Preview is not available but you can still link to this website<br />
                    <a v-bind:href="props.url" class="btn btn-block btn-primary mt-2">Open website</a>
                  </div>
                </template>
              </link-prevue>
            </div>

            <!-- DESIGN POLL -->
            <div class="alert alert-secondary mt-2 mb-0" v-if="subPanel === 'poll'">
              <p>What do you want to ask?</p>

              <div class="input-group mt-2 mb-2">
                <input type="input" placeholder="Question or Statement" v-model="form.attachment.title" class="form-control" />
                <div class="input-group-append" v-if="form.attachment.title">
                  <button class="btn btn-default" type="button" id="button-addon2" @click.prevent="closeAttachment"><i class="fas fa-times"></i></button>
                </div>
              </div>

              <div class="float-right d-lg-block d-none">
                <select class="form-control" v-model="form.attachment.optionTemplate" @change="setOptions">
                  <option selected value="" disabled>- Use a template -</option>
                  <option value="yesno">Yes / No</option>
                  <option value="agree-disagree">Agree / Disagree</option>
                </select>
              </div>

              <p class="mt-4 mb-3">What are the options available to your members?</p>

              <div class="input-group mb-3" v-for="(option, index) in form.attachment.options" v-bind:key="index">
                <div class="input-group-prepend">
                  <span class="input-group-text small" id="basic-addon1">{{ index + 1 }}</span>
                </div>
                <input type="text" class="form-control" v-model="option.label" placeholder="Option" aria-label="Option" aria-describedby="basic-addon1" />
                <div class="input-group-append">
                  <button class="btn btn-default" type="button" id="button-addon2" @click.prevent="deleteOption(index)"><i class="fas fa-times"></i></button>
                </div>
              </div>

              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text small" id="basic-addon1">{{ form.attachment.options.length + 1 }}</span>
                </div>
                <input type="text" class="form-control" placeholder="New option" v-model="form.attachment.optionText" aria-label="Option" aria-describedby="basic-addon1" />
                <div class="input-group-append" v-if="form.attachment.optionText">
                  <button class="btn btn-default" type="button" id="button-addon2" @click.prevent="commitOption"><i class="fas fa-check"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <h4 class="card-title text-default font-weight-bold mb-0 text-center">Feed 1</h4> -->
        <div class="justify-content-center mt-4">
          <div class="mt-4 mb-4 text-center" v-if="posts.length === 0 && user.loggedIn">
            <div class="alert alert-white border border-muted text-center font-weight-bold p-4" v-if="groupPosts.length > 0">
              <h4 class="text-default mb-4"><small>There are no posts for the selected members</small></h4>
              <img src="/img/ill/ill-feed.svg" class="img-inthought mb-4" />
            </div>

            <div class="alert alert-white border border-muted text-center font-weight-bold p-4" v-else>
              <h4 class="text-default mb-4"><small>Be the first to start a thread in the group</small></h4>
              <img src="/img/ill/ill-feed.svg" class="img-inthought mb-4" />
            </div>
          </div>

          <div class="card shadow rounded mt-2 mr-0" v-for="(post, index) in posts" v-bind:key="index">
            <div class="body" style="position: relative" v-if="post.status === 'submitted'">
              <div class="m-2 card-ellipse" v-if="deleteAllowed(post)">
                <base-dropdown position="right">
                  <a role="button" class="pointer" slot="title" data-toggle="dropdown" @click="entry = post">
                    <icon name="fad fa-ellipsis-h" size="sm" iconOnly textColor="default" type="light" outline rounded></icon>
                  </a>

                  <!-- <a class="dropdown-item pointer" role="button" @click="action = 'edit'">
                                        <i class="fal fa-pencil"></i> Edit
                                    </a> -->
                  <a class="dropdown-item pointer" role="button" @click="setAction('delete')"> <i class="fal fa-trash"></i> Delete </a>
                </base-dropdown>
              </div>
              <div class="m-lg-3 m-1">
                <div class="mt-2 mb-0">
                  <div class="float-left ml-2 mr-2">
                    <img alt="Image placeholder" :class="getAvatarClass(post.user.uid)" :src="post.user.photoURL" />
                  </div>

                  <p class="font-weight-bold text-default mt-2 mb-0">{{ post.user.fullName }}</p>
                  <p class="text-muted mb-3" style="margin-top: -10px">
                    <small>
                      {{ $dayjs.unix( post.creationSeconds ).fromNow() }}
                    </small>
                  </p>
                </div>

                <div class="text-sm mb-2 mr-0 text-dark" style="white-space: pre-wrap" v-html="post.text" />

                <report-share :share-link="post.attachment" v-if="post.attachment.type === 'report'"></report-share>
                <video-embed class="rounded" :src="post.attachment.url" v-if="post.attachment.type === 'video'"></video-embed>
                <image-embed :attachment="post.attachment" v-if="post.attachment.type === 'image'"></image-embed>
                <website-embed :attachment="post.attachment" v-if="post.attachment.type === 'website'"></website-embed>
                <poll-embed :post="post" v-if="post.attachment.type === 'poll'"></poll-embed>
              </div>
              <div class="bg-white">
                <div class="container">
                  <div class="row justify-content-center bg-gradient-default">
                    <div class="col-lg-10 col p-2">
                      <reactions :post="post"></reactions>
                    </div>
                    <div class="col-lg-2 col-md-3 col p-2 justify-content-right text-right">
                      <span class="badge badge-white pl-2 pr-2 text-right badge-count pointer" @click="toggleComments(post.id)">
                        <span class="text-default" v-if="post.replies.length > 0">
                          <span class="ml-2 mr-1 font-weight-bold">
                            {{ post.replies.length }}
                          </span>
                        </span>

                        <span class="text-default" v-else> 0 </span>

                        <span>
                          <img src="/img/images/comments.svg" class="comments-count-image ml-1" />
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="row justify-content-center" v-if="activeComments(post.id).length">
                    <div class="col-lg-12 col p-2">
                      <replies :post="post"></replies>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="body bg-default rounded" style="position: relative" v-if="post.status === 'notification'">
              <div class="m-lg-3 m-1 text-white-50 text-center">
                <small> <i class="fad fa-exclamation-circle mr-1"></i> <span v-html="post.text" /> - {{ $dayjs.unix( post.creationSeconds ).fromNow() }} </small>
              </div>
            </div>
          </div>

          <!-- <button @click="getGroupFeedArchive">Get More</button> -->

          <div v-if="action">
            <feed-modals :entry="entry" :action="action" v-on:modalClosed="modalWasClosed"></feed-modals>
          </div>
        </div>

      </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { db } from "@/firebase";
import store from "@/store.js";
import { mapGetters } from "vuex";

import BaseDropdown from "@/components/BaseDropdown";

import FeedModals from "@/components/mygroups/FeedModals";

import ReportShare from "@/components/embeds/ReportShare";
import VideoEmbed from "@/components/embeds/Video";
import ImageEmbed from "@/components/embeds/Image";
import WebsiteEmbed from "@/components/embeds/Website";
import PollEmbed from "@/components/embeds/Poll";
import LinkPrevue from "link-prevue";

import Reactions from "@/components/mygroups/Reactions";
import Replies from "@/components/mygroups/Replies";
import reactionTypes from "@/models/reactionTypes";
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "feed",
  props: ["groupUid", "visibleMembers"],
  components: {
    BaseDropdown,
    ReportShare,
    VideoEmbed,
    PollEmbed,
    ImageEmbed,
    WebsiteEmbed,
    Reactions,
    Replies,
    vueDropzone,
    LinkPrevue,
    FeedModals,
  },

  data() {
    return {
      action: null,
      entry: null,
      publicReportsLoading: true,
      publicReports: [],
      groupPosts: [],

      pageEnd: 10,
      postsPerPage: 10,

      // ARCHIVE
      groupPostArchive: [],
      querying: false,
      query: {
        creationSeconds: null,
        offset: 0,
        downloaded: [],
      },

      commentsEnabled: [],
      form: {
        emailNotice: false,
        grouppost: "",
        attachmentSelected: null,
        attachment: {},
      },
      displayRego: false,
      subPanel: null,
      foundURL: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
                <p class="form-text">Allowed Files: .jpg, .jpeg, .png</p>`,
      },
      images: [],
      uploadedImages: [],
    };
  },

  mounted() {
    this.scroll();

    this.$watch("$refs.linkPreview.response", {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler(newVal, oldVal) {
        if (!newVal) {
          return;
        }

        if (this.form.attachment.type === "website" && this.form.attachment.url) {
          this.form.attachment = {
            type: "website",
            title: newVal.title,
            image: newVal.image,
            description: newVal.description,
            url: this.form.attachment.url,
          };
        }
      },
    });
  },

  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      // map `this.groups` to `this.$store.getters.groups`
      user: "user",
      groups: "groups",
    }),

    commsIcon(){

      return 'mr-2 fab fa-' + this.currentGroup.groupComms

    },

    sortedReports() {
      if (this.publicReports.length > 0) {
        var reports = this.publicReports;
        return reports.sort((b, a) => (a.startDate > b.startDate ? 1 : -1));
      } else {
        return [];
      }
    },

    shareLink() {
      return {
        fullName: this.user.data.fullName,
        startDate: this.form.attachment.startDate,
        endDate: this.form.attachment.endDate,
        label: this.form.attachment.label,
        photoURL: this.user.data.photoURL,
        url: this.form.attachment.url,
      };
    },

    imageLinks() {
      if (!this.uploadedImages) {
        return [];
      }

      return this.uploadedImages;
    },

    currentGroup() {
      if (!this.groups || !this.groupUid) {
        return {};
      }

      let group = this.groups.filter((group) => {
        return group.id === this.groupUid;
      });

      return group[0];
    },

    selectedMembers() {
      if (!this.visibleMembers) {
        return {};
      }

      return this.visibleMembers.filter((member) => {
        return member.visible;
      });
    },

    posts() {
      if (!this.currentGroup) {
        return [];
      }

      let allPosts = [...this.groupPosts, ...this.groupPostArchive];

      // If selected members and total group counts are equal
      // then we will just show all posts
      // this is because otherwise content from users who leave will be hidden
      if (this.currentGroup.members.length === this.selectedMembers.length) {
        return allPosts.slice(0, this.pageEnd);
      }

      let posts = allPosts.filter((post) => {
        return this.checkVisibility(post.user.uid) || post.user.uid === this.groupUid;
      });

      return posts.slice(0, this.pageEnd);
    },
  },

  watch: {
    subPanel(view) {
      if (!view) {
        return;
      }

      if (view === "report") {
        this.bindPublicReports();
      }

      if (view === "image") {
        this.form.attachment.images = [];
      }

      this.form.attachment.type = view;
    },

    uploadedImages() {
      this.form.attachment.images = this.uploadedImages;
    },

    form: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler(newVal, oldVal) {
        if (!this.foundURL) {
          var reg = new RegExp(/(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$] )/gim);
          var url = reg.exec(newVal.grouppost);

          if (url) {
            this.setWebAttachment(url[0]);
            this.foundURL = true;
          }
        }
      },
    },

    // groupPosts(){
    //     console.log(this.groupPosts)
    // }
  },

  methods: {

    scroll() {
      window.onscroll = () => {
        let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          this.pageEnd += this.postsPerPage;
        }
      };
    },

    checkVisibility(uid) {
      if (this.visibleMembers.some((el) => el.uid === uid && el.visible === true)) {
        return true;
      }

      return false;
    },

    getLastCreationSecond() {
      let index = this.groupPosts.length - 1;
      return this.groupPosts[index].creationSeconds;
    },

    getGroupFeedArchive() {
      // If we have already downloaded, don't query BQ again
      // if (this.checkDate(this.startDate, this.endDate)) {
      //     this.building = true;
      //     setTimeout(this.buildData, 500)
      //     return
      // }

      const vm = this;

      this.querying = true;

      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          user.getIdToken().then(function (idToken) {
            // Get our data!
            vm.bigQuery(idToken);
          });
        }
      });
    },

    bigQuery(idToken) {
      const vm = this;
      const axios = require("axios");

      let start = vm.getLastCreationSecond();

      vm.$analytics.logEvent("group_feed_query", {
        groupUid: vm.groupUid,
        uid: vm.user.data.uid,
        fullName: vm.user.data.fullName,
        start: start,
      });

      // Send token to your backend via HTTPS
      var config = {
        headers: {
          Authorization: "Bearer " + idToken,
        },
      };

      // let url = 'http://localhost:5001/my-reflection-22932/australia-southeast1/app/api/group_feed_query?start=' + start + '&group=' + vm.groupUid
      let url = "https://australia-southeast1-my-reflection-22932.cloudfunctions.net/app/api/group_feed_query?start=" + start + "&group=" + vm.groupUid;

      // Make a request for a user with a given ID
      axios
        .get(url, config)
        .then(function (response) {
          // handle success
          vm.convertFeed(response.data);

          vm.query.downloaded.push({
            offset: vm.query.offset,
          });
          vm.query.offset++;
        })
        .catch(function (error) {
          // handle error
          // console.log(error)
        })
        .finally(function () {
          // always executed
          vm.querying = false;
          // vm.building = false
        });
    },

    convertFeed(data) {
      const vm = this;

      let feedCheck = [];
      let index;

      data.forEach(function (entry, i) {
        // memberReactions_member, memberReactions_index, replies_member, replies_index

        let creationTime = entry.creationTime;
        let creationSeconds = parseInt(entry.creationSeconds);
        let document_id = entry.document_id;
        let groupUid = entry.groupUid;
        let text = entry.text;
        let user = {
          fullName: entry.user_fullName,
          photoURL: entry.user_photoURL,
          uid: entry.user_uid,
        };
        let attachment = {
          type: entry.attachment_type,
          startDate: entry.attachment_startDate,
          endDate: entry.attachment_endDate,
          fullName: entry.attachment_fullName,
          photoURL: entry.attachment_photoURL,
          label: entry.attachment_label,
          title: entry.attachment_title,
          description: entry.attachment_description,
          image: entry.attachment_image,
          url: entry.attachment_url,
          images: [],
          options: [],
          votes: [],
        };

        let attachment_images_index = entry.attachment_images_index;
        let attachment_images_member = null;
        if (entry.attachment_images_member) {
          attachment_images_member = JSON.parse(entry.attachment_images_member);
        }

        let attachment_options_index = entry.attachment_options_index;
        let attachment_options_member = null;
        if (entry.attachment_options_member) {
          attachment_options_member = JSON.parse(entry.attachment_options_member);
        }

        let attachment_votes_index = entry.attachment_votes_index;
        let attachment_votes_member = null;
        if (entry.attachment_votes_member) {
          attachment_votes_member = JSON.parse(entry.attachment_votes_member);
        }

        let memberReactions_index = entry.memberReactions_index;
        let memberReactions_member = null;
        if (entry.memberReactions_member) {
          memberReactions_member = JSON.parse(entry.memberReactions_member);
        }

        let replies_index = entry.replies_index;
        let replies_member = null;
        if (entry.replies_member) {
          replies_member = JSON.parse(entry.replies_member);
        }

        // If we haven't see this reflection yet
        if (feedCheck.indexOf(document_id) === -1) {
          var rMap = {
            creationTime: creationTime,
            creationSeconds: creationSeconds,
            id: document_id,
            groupUid: document_id,
            text: text,
            user: user,
            attachment: attachment,
            replies: [],
            memberReactions: [],
            reactions: JSON.parse(JSON.stringify(reactionTypes)),
            source: "archive",
          };

          // store our document_id in our check object
          feedCheck.push(document_id);

          // Create our reflection record
          index = vm.groupPostArchive.push(rMap) - 1;
        }

        // If we have a image, add it
        if (attachment_images_member) {
          vm.groupPostArchive[index].attachment.images[attachment_images_index] = attachment_images_member;
        }

        // If we have a poll, add options and votes
        if (attachment_options_member) {
          vm.groupPostArchive[index].attachment.options[attachment_options_index] = attachment_options_member;
        }
        if (attachment_votes_member) {
          vm.groupPostArchive[index].attachment.votes[attachment_votes_index] = attachment_votes_member;
        }

        // if we have replies, add them
        if (replies_member) {
          vm.groupPostArchive[index].replies[replies_index] = replies_member;
        }

        // if we have memberReactions, add them
        if (memberReactions_member) {
          vm.groupPostArchive[index].memberReactions[memberReactions_index] = memberReactions_member;
        }
      });
    },

    setAction(action) {
      this.action = null;
      setTimeout(this.setActionDelayed(action), 2000);
    },

    setActionDelayed(action) {
      this.action = action;
    },

    modalWasClosed() {
      this.action = null;
    },

    deleteAllowed(post) {
      if (this.currentGroup.ownerId === this.user.data.uid || post.user.uid === this.user.data.uid) {
        return true;
      }

      return false;
    },

    async afterComplete(upload) {
      // this.form.attachment.images = JSON.parse(JSON.stringify(this.images))
      const vm = this;

      var imageName = this.$uuid.v4();
      this.isLoading = true;
      try {
        //save image
        let file = upload;
        var metadata = {
          contentType: "image/png",
        };
        var storageRef = firebase.storage().ref("groups/" + this.groupUid);
        var imageRef = storageRef.child(`images/${imageName}.png`);
        await imageRef.put(file, metadata);
        var downloadURL = await imageRef.getDownloadURL();

        let imgDoc = {
          src: downloadURL,
          filename: imageName + ".png",
          metadata: metadata,
        };
        this.uploadedImages.push(imgDoc);

        // Vue.set(example1.items, indexOfItem, newValue)
      } catch (error) {
        // console.log(error);
      }

      this.$refs.imgDropZone.removeFile(upload);
    },

    deleteImage(image, index) {
      // Create a reference to the file to delete
      var storageRef = firebase.storage().ref("groups/" + this.groupUid);
      var imageRef = storageRef.child(`images/${image.filename}`);

      // Delete the file
      imageRef
        .delete()
        .then(function (response) {
          // File deleted successfully
        })
        .catch(function (error) {
          // Uh-oh, an error occurred!
          // console.log(error)
        });

      this.uploadedImages.splice(index, 1);
    },

    activeComments(postId) {
      return this.commentsEnabled.filter((post) => {
        return post.id === postId;
      });
    },

    toggleComments(postId) {
      let found = false;
      let index = -1;
      var tmpActive = this.commentsEnabled;
      tmpActive.forEach((active, i) => {
        if (active.id === postId) {
          found = true;
          index = i;
        }
      });

      if (!found) {
        this.commentsEnabled.push({
          id: postId,
        });
      } else {
        this.commentsEnabled.splice(index, 1);
      }
    },

    closeAttachment() {
      this.form.attachmentSelected = null;
      this.form.attachment = {};
      this.uploadedImages = [];
    },

    setWebAttachment(url) {
      this.form.attachment = {
        type: "website",
        title: "",
        image: "",
        description: "",
        url: url.trim(),
      };

      this.subPanel = "website";
    },

    setReportAttachment() {
      let index = this.form.attachmentSelected;
      if (!typeof index === "number") {
        return;
      }

      let report = this.sortedReports[index];

      let label = report.label;
      if (!label) {
        label = "Unnamed report";
      }

      let startDate = this.$dayjs(report.startDate).format("MMM Do, YYYY");

      this.form.attachment = {
        type: "report",
        startDate: report.startDate,
        endDate: report.endDate,
        fullName: this.user.data.fullName,
        photoURL: this.user.data.photoURL,
        label: label,
        title: label + " [ " + startDate + " ]",
        url: "https://myreflections.app/shared/" + report.publicLink,
      };
    },

    bindPublicReports() {
      if (this.publicReports.length === 0) {
        // $bind automatically unbinds the previously bound property
        this.$bind("group", db.collection("weeklyReflections").where("uid", "==", this.user.data.uid).where("publicLink", "!=", null).orderBy("publicLink", "desc")).then((reports) => {
          this.publicReports = reports;
          this.publicReportsLoading = false;
        });
      }
    },

    setOptions() {
      let option = this.form.attachment.optionTemplate;
      if (option === "yesno") {
        this.form.attachment.options = [
          {
            label: "Yes",
            votes: 0,
          },
          {
            label: "No",
            votes: 0,
          },
        ];
      }
      if (option === "agree-disagree") {
        this.form.attachment.options = [
          {
            label: "Strongly Agree",
            votes: 0,
          },
          {
            label: "Agree",
            votes: 0,
          },
          {
            label: "Neither Agree or Disagree",
            votes: 0,
          },
          {
            label: "Disagree",
            votes: 0,
          },
          {
            label: "Strongly Disagree",
            votes: 0,
          },
        ];
      }
    },

    commitOption() {
      this.form.attachment.options.push({
        label: this.form.attachment.optionText,
        votes: 0,
      });
      this.form.attachment.optionText = "";
    },

    deleteOption(index) {
      this.form.attachment.options.splice(index, 1);
    },

    buildPollStructure() {
      this.form.attachment = {
        type: "poll",
        options: [],
        votes: [],
        optionText: "",
        optionTemplate: "",
      };
    },

    toggleSubPanel(type) {
      if (this.subPanel !== type) {
        if (type === "poll") {
          this.buildPollStructure();
        }

        this.subPanel = type;
        this.form.type = type;
      } else {
        this.subPanel = null;
        this.form.type = null;
      }
    },

    getDate(datetime) {
      return new Date(datetime * 1000);
    },

    getAvatarClass(uid) {
      let avatar = "avatar";
      if (!this.$isDesktop()) {
        avatar = "avatar-sm";
      }

      if (!this.user.data) {
        return avatar + " avatar-else rounded-circle";
      }

      if (uid === this.user.data.uid) {
        return avatar + " avatar-self rounded-circle";
      } else {
        return avatar + " avatar-else rounded-circle";
      }
    },

    createNotifications(subject, group, recipients) {
      const vm = this;

      let groupId = group.id;

      let allRecipients = recipients;
      let noticeToUids = Array();

      allRecipients.forEach((doc) => {
        noticeToUids.push(doc.uid);
      });

      var doc = db.collection("mail").doc();

      let message = "There is a new thread on the " + group.groupName + " group feed! @ My Reflections";
      let cta = "https://www.myreflections.app/mygroups/" + groupId;
      let btn_text = "Open Group Feed";
      let cta_text = "\n\nClick here to view and engage with your group!\n" + cta;

      let mail = {
        from: "My Reflections <noreply@myreflections.app>",
        toUids: noticeToUids,
        message: {
          subject: subject,
          text: message + cta_text,
          html:
            '<!DOCTYPE html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title></title> <!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1"><style type="text/css">#outlook a{padding:0}.ReadMsgBody{width:100%}.ExternalClass{width:100%}.ExternalClass *{line-height:100%}body{margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}table,td{border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt}img{border:0;height:auto;line-height:100%;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic}p{display:block;margin:13px 0}</style><!--[if !mso]><!--><style type="text/css">@media only screen and (max-width:480px){@-ms-viewport{width:320px}@viewport{width:320px}}</style><!--<![endif]--> <!--[if mso]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--> <!--[if lte mso 11]><style type="text/css">.outlook-group-fix{width:100% !important}</style><![endif]--> <!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700" rel="stylesheet" type="text/css"><link href="https://fonts.googleapis.com/css?family=Cabin:400,700" rel="stylesheet" type="text/css"><style type="text/css">@import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);@import url(https://fonts.googleapis.com/css?family=Cabin:400,700);</style><!--<![endif]--><style type="text/css">@media only screen and (min-width:480px){.mj-column-per-100{width:100% !important;max-width:100%}}</style><style type="text/css">@media only screen and (max-width:480px){table.full-width-mobile{width:100% !important}td.full-width-mobile{width:auto !important}}</style><style type="text/css">.hide_on_mobile{display:none !important}@media only screen and (min-width: 480px){.hide_on_mobile{display:block !important}}.hide_section_on_mobile{display:none !important}@media only screen and (min-width: 480px){.hide_section_on_mobile{display:table !important}}.hide_on_desktop{display:block !important}@media only screen and (min-width: 480px){.hide_on_desktop{display:none !important}}.hide_section_on_desktop{display:table !important}@media only screen and (min-width: 480px){.hide_section_on_desktop{display:none !important}}[owa] .mj-column-per-100{width:100%!important}[owa] .mj-column-per-50{width:50%!important}[owa] .mj-column-per-33{width:33.333333333333336%!important}p{margin:0px}@media only print and (min-width:480px){.mj-column-per-100{width:100%!important}.mj-column-per-40{width:40%!important}.mj-column-per-60{width:60%!important}.mj-column-per-50{width:50%!important}mj-column-per-33{width:33.333333333333336%!important}}</style></head><body style="background-color:#FFFFFF;"><div style="background-color:#FFFFFF;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#8D6C9F;background-color:#8D6C9F;width:100%;"><tbody><tr><td> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:15px 15px 15px 15px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:210px;"><img alt="My Reflections" height="auto" src="https://firebasestorage.googleapis.com/v0/b/my-reflection-22932.appspot.com/o/FCMImages%2Fhor-white-nobrain-w350.png?alt=media&amp;token=445697bf-37e1-4302-a3ca-70fee26df5ad" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="210"></td></tr></tbody></table></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="background:#FFFFFF;background-color:#FFFFFF;Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#FFFFFF;background-color:#FFFFFF;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:0px 20px 0px 20px;word-break:break-word;"><div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:11px;line-height:1.5;text-align:center;color:#000000;"><h3 style="font-family: &apos;Cabin&apos;, sans-serif; font-size: 20px; color: #555555; line-height: 100%;">' +
            subject +
            '</h3></div></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="background:#FFFFFF;background-color:#FFFFFF;Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#FFFFFF;background-color:#FFFFFF;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="left" style="font-size:0px;padding:15px 15px 15px 15px;word-break:break-word;"><div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:11px;line-height:1.5;text-align:left;color:#000000;"><p style="text-align: center;"><span style="font-size: 16px;">' +
            message +
            '</span></p></div></td></tr><tr><td align="center" vertical-align="middle" style="font-size:0px;padding:15px 15px 15px 15px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;width:auto;line-height:100%;"><tbody><tr><td align="center" bgcolor="#8D6C9F" role="presentation" style="border:none;border-radius:0px;cursor:auto;mso-padding-alt:10px 30px 10px 30px;background:#8D6C9F;" valign="middle"> <a href="' +
            cta +
            '" style="display:inline-block;background:#8D6C9F;color:#ffffff;font-family:Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif;font-size:15px;font-weight:normal;line-height:100%;Margin:0;text-decoration:none;text-transform:none;padding:10px 30px 10px 30px;mso-padding-alt:0px;border-radius:0px;" target="_blank">' +
            btn_text +
            '</a></td></tr></tbody></table></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;"><tbody><tr><td style="padding:4px;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;"><tbody><tr><td style="font-size:0;height:35px;vertical-align:middle;width:35px;"> <a href="https://www.facebook.com/myreflectionsapp" target="_blank"> <img height="35" src="https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/facebook.png" style="border-radius:3px;display:block;" width="35"> </a></td></tr></tbody></table></td></tr></tbody></table> <!--[if mso | IE]></td><td> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;"><tbody><tr><td style="padding:4px;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;"><tbody><tr><td style="font-size:0;height:35px;vertical-align:middle;width:35px;"> <a href="https://www.twitter.com/myreflections20" target="_blank"> <img height="35" src="https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/twitter.png" style="border-radius:3px;display:block;" width="35"> </a></td></tr></tbody></table></td></tr></tbody></table> <!--[if mso | IE]></td><td> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;"><tbody><tr><td style="padding:4px;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;"><tbody><tr><td style="font-size:0;height:35px;vertical-align:middle;width:35px;"> <a href="https://www.instagram.com/myreflectionsapp/" target="_blank"> <img height="35" src="https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/instagram.png" style="border-radius:3px;display:block;" width="35"> </a></td></tr></tbody></table></td></tr></tbody></table> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr><tr><td style="font-size:0px;padding:10px 25px;padding-top:10px;padding-right:100px;padding-bottom:10px;padding-left:100px;word-break:break-word;"><p style="border-top:solid 1px #CCCCCC;font-size:1;margin:0px auto;width:100%;"></p> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 1px #CCCCCC;font-size:1;margin:0px auto;width:400px;" role="presentation" width="400px" ><tr><td style="height:0;line-height:0;"> &nbsp;</td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:0px 0px 0px 0px;word-break:break-word;"><div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:15px;line-height:1.5;text-align:center;color:#949494;"><p><span style="font-size: 12px;">Copyright &#xA9; 2020 My Reflections, All rights reserved.&#xA0;<br></span></p></div></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div></body></html>',
        },
      };

      var doc = db
        .collection("mail")
        .doc(doc.id)
        .set(mail)
        .then(function () {
          vm.$toast.open({
            message: "Notification(s) Sent!",
            type: "success",
            // all of other options may go here
          });
        });
    },

    commitGroupPost() {
      const vm = this;

      let ourDate = new Date();
      let timeStamp = new firebase.firestore.Timestamp.fromDate(ourDate);

      if (vm.form.emailNotice) {
        let subject = "New Group Thread for " + this.currentGroup.groupName;
        vm.createNotifications(subject, this.currentGroup, this.currentGroup.members);
      }

      var post = db.collection("groupPosts").doc();

      let grouppost = {
        id: post.id,
        user: {
          fullName: this.user.data.fullName,
          photoURL: this.user.data.photoURL,
          uid: this.user.data.uid,
        },
        groupUid: this.groupUid,
        text: this.form.grouppost,
        creationTime: timeStamp,
        creationSeconds: timeStamp.seconds,
        status: "submitted",
        attachment: this.form.attachment,
        replies: [],
        memberReactions: [],
        reactions: JSON.parse(JSON.stringify(reactionTypes)),
      };

      db.collection("groupPosts")
        .doc(post.id)
        .set(grouppost)
        .then(function (docRef) {
          vm.$analytics.logEvent("group_post", {
            postId: post.id,
            groupUid: vm.groupUid,
            uid: vm.user.data.uid,
            fullName: vm.user.data.fullName,
            creationTime: timeStamp,
            text: vm.form.grouppost,
          });

          // console.log(docRef.id);
          vm.form.grouppost = "";
          vm.closeAttachment();
          vm.subPanel = null;
          vm.$toast.open({
            message: "Post added",
            type: "success",
            // all of other options may go here
          });
        })
        .catch(function (error) {
          vm.$toast.open({
            message: "Something went wrong!",
            type: "error",
            duration: 10000,
            // all of other options may go here
          });
        });
    },
  },
  firestore() {
    return {
      groupPosts: db.collection("groupPosts").where("groupUid", "==", this.groupUid).orderBy("creationSeconds", "desc").limit(35),
    };
  },
};
</script>

<style scoped>

.avatar-self {
  border: 3px solid #8d6c9f;
}

.avatar-else {
  border: 3px solid #999;
}

.card-ellipse {
  position: absolute;
  text-align: right;
  top: 0;
  right: 0;
  z-index: 50;
}

.preview-image {
  max-width: 250px;
  width: 100%;
  margin: 15px;
}

.badge-count {
  border-radius: 24px;
}

.comments-count-image {
  width: 24px;
  height: 24px;
}

.comment {
  display: flex;
  align-items: flex-start;
}

.comment-body {
  flex: 1;
}

.comment-footer {
  border-top: 1px solid rgba(141, 108, 159, 0);
}

.comment-grouppost-avatar {
  margin-top: -4px;
  margin-right: -1rem;
  position: relative;
  z-index: 1;
  width: 42px;
  height: 42px;
  transition: all 0.15s ease;
}

.comment-grouppost-avatar-self {
  border: 3px solid #8d6c9f;
}

.comment-grouppost-avatar-else {
  border: 3px solid #999;
}

@media (prefers-reduced-motion: reduce) {
  .comment-grouppost-avatar {
    transition: none;
  }
}

.comment-grouppost-text {
  border-radius: 0.3rem;
  border-top-left-radius: 0;
  position: relative;
  background-color: #fff !important;
  padding: 1rem 1.25rem 1rem 2.5rem;
}

.comment-grouppost:hover .comment-grouppost-avatar {
  transform: scale(1.1);
}
</style>
